// @flow

import { MiddlewareRegistry } from '../redux';
import {
    ALREADY_PARTICIPANT_JOINED,
    DELETE_PIN_PARTICIPANT,
    MUTE_REMOTE_PARTICIPANT,
    PARTICIPANT_HANDLER_JOIN,
    PARTICIPANT_JOINED,
    PARTICIPANT_LEFT,
    PIN_PARTICIPANT, SET_RECORDING_PARTICIPANT
} from './actionType';

import { createTaskQueue } from '../../../modules/util/helpers';
import { getNicknameByUserID } from '../../group';
import { CLEAR_ROOM, CONFERENCE_LEFT, INIT_ROOM, SET_GROUP_UUID } from '../conference';
import { MEDIA_TYPE } from '../media';
import { handlerParticipantJoined, participantLeft, participantUpdated, pinParticipant, setBridgeParticipant, setRecordingParticipant } from './actions';
import { getParticipantById } from './function';

const task = createTaskQueue();
let sleepTime;
MiddlewareRegistry.register(({ getState, dispatch }) => next => async action => {
    switch (action?.type) {
        case MUTE_REMOTE_PARTICIPANT: {
            if (action?.mediaType === MEDIA_TYPE.VIDEO) APP.mateManagement.setMemberCamera(action?.id, action.muted);
            else if (action?.mediaType === MEDIA_TYPE.AUDIO) APP.mateManagement.setMemberMic(action?.id, action.muted);
            break;
        }

        case PIN_PARTICIPANT:
        case DELETE_PIN_PARTICIPANT:
        case SET_RECORDING_PARTICIPANT:
            const participant = getParticipantById(getState(), action.participantId);
            if (participant) {
                if (action.type === PIN_PARTICIPANT) participant.pinned = true;
                if (action.type === DELETE_PIN_PARTICIPANT) participant.pinned = false;
                if (action.type === SET_RECORDING_PARTICIPANT) participant.recording = action.record;

                dispatch(participantUpdated(participant));
            }                
            break;
        
        case CLEAR_ROOM:
        case CONFERENCE_LEFT: {
            clearTimeout(sleepTime);
            const { remote } = getState()['features/base/participants'];

            [...remote.values()].map(value => {
                dispatch(participantLeft(value));
            });

            task.clear();
            break;
        }

        case PARTICIPANT_LEFT:
            task.enqueue(onFinish => {
                sleepTime = setTimeout(onFinish, 500);
                return next(action);
            });
            return;

        case ALREADY_PARTICIPANT_JOINED:
            task.enqueue(onFinish => {
                var { participants, group_id } = action;
                let participants_count = participants.length;
                if (participants.length <= 0) onFinish();
                participants.map(p => {
                    participants_count--;

                    if (p.user_uuid === '') {
                        if (participants_count <= 0) onFinish();
                        return;
                    }
        
                    const participant = {
                        ...p,
                        pinned: p.pinned,
                        recording: p.recording,
                        nickname: p.nickname,
                        local: false,
                        entryTime: Date.now(),
                        existed: true,
                        hidden: p.type === "hidden"
                    };
            
                    dispatch(handlerParticipantJoined(participant, false, action.group_id));        
                    if (p.pinned) dispatch(pinParticipant(p.user_uuid));
                    if (p.recording) dispatch(setRecordingParticipant(p.user_uuid, true));
                    if (p.jitsi_id !== "") dispatch(setBridgeParticipant(p.user_uuid, p.jitsi_id));
                    if (participants_count <= 0) sleepTime = setTimeout(onFinish, 500);
                });
            });
            break;

        case PARTICIPANT_HANDLER_JOIN:
            task.enqueue(async onFinish => {
                dispatch(handlerParticipantJoined(action.participant, action.isLocal, action.group_id));        
                onFinish();
            });
            break;

        case PARTICIPANT_JOINED:
            if (action.participant.nickname === "") {
                const nickname = await getNicknameByUserID(action.participant.user_uuid);

                return next({
                    ...action,
                    participant: {
                        ...action.participant,
                        nickname
                    }
                }); 
            } 
            
            break;
            
    }
    return next(action);
});
